
import React from 'react';
import SVGComponent from '../SVG/SVGComponent';
import { SVG_ICONS } from '../../constants';

/**
 * @module Modals/ConfirmationModal
 */
/**
 * @typedef {object} props
 * @property {object} modalData
 * @property {string} modalData.heading
 * @property {string} modalData.title
 * @property {Array} modalData.additionalMessages
 * @property {Function} cancel
 * @property {Function} confirmation
 */

/**
 * @param {props} props
 * @returns {view}
 */
const ConfirmationModal = (props) => (
  <div className="dialog open">
    <div className="dialog__heading">
      <span className="dialog__title">{props.modalData.heading}</span>
      <SVGComponent
        onClick={props.cancel}
        className="icon-xxs  dialog__close"
        src={`${SVG_ICONS.utility}#close`}
      />
    </div>
    <div className="dialog__content">
      <div className="dialog__info">
        {props.modalData.title}
      </div>
      <div className="dialog__info text-center">
        {props.modalData.additionalMessages.map((msg) => (
          <p key={msg}>
            <strong>
              {msg}
            </strong>
          </p>
        ))}
      </div>
    </div>
    <div className="dialog__btn-wrap">
      <button
        id="no_ConfirmationModal"
        type="button"
        className="btn btn-secondary"
        onClick={props.cancel}
      >
        No
      </button>
      <button
        id="yes_ConfirmationModal"
        type="button"
        className="btn btn-primary m-l-10"
        onClick={props.confirmation}
      >
        Yes
      </button>
    </div>
  </div>
);

export default ConfirmationModal;